var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-inline-block"},[(_vm.isTrial)?_c('v-tooltip',{scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_vm._t("trial-content")]},proxy:true},{key:"popover",fn:function(){return [_vm._v("\n      To view, upgrade now\n    ")]},proxy:true}],null,true)}):_vm._t("premium-content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }